// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpNumberField } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const NumberField = wrap(jpNumberField(), {
    events: { onChange: 'change', onInput: 'input' }
});
// @ts-expect-error unknown property
NumberField.displayName = 'Jupyter.NumberField';
